import React from 'react';
import { Descriptions } from 'antd';
import { useStore } from 'routes/inventorize_meter/useStore';
import { ImageUploadReview } from 'components/ImageUpload/ImageUploadReview';
import { FormattedMessage, useIntl } from 'react-intl';
import { meterMountTypeTranslated } from 'components/Form/meter_details/constants';
import { InventoryMeterMountType } from '@enmon/commons/lib/tools';
import { ReadingDescriptions as messages } from '../messages';
import { outputTechnologyTranslated } from '../../../../../components/Form/meter_details/messages';

/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
export const ReadingDescriptions: React.VFC = () => {
  const intl = useIntl();
  const {
    calibrated,
    manufactured,
    photoMeterModuleList,
    meterMountType,
    meterMountTechnology,
    requiresManualAks,
    remoteReadingOwner,
    remoteReadingSerial,
  } = useStore();

  return (
    <Descriptions
      bordered
      column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
      size="small"
      title={<FormattedMessage {...messages.mounting} />}
    >
      <Descriptions.Item label={<FormattedMessage {...messages.modulePhotos} />} span={2}>
        <ImageUploadReview fileList={photoMeterModuleList} previewWidth={150} />
      </Descriptions.Item>

      <Descriptions.Item label={<FormattedMessage {...messages.requiresManualAks} />}>
        {requiresManualAks ? <FormattedMessage {...messages.yes} /> : <FormattedMessage {...messages.no} />}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.installationStatus} />}>
        {meterMountType ? intl.formatMessage(meterMountTypeTranslated[meterMountType]) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.meterMountTechnology} />}>
        {meterMountTechnology ? intl.formatMessage(outputTechnologyTranslated[meterMountTechnology]) : ''}
      </Descriptions.Item>
      {meterMountType && meterMountType !== InventoryMeterMountType.Free && (
        <>
          <Descriptions.Item label={<FormattedMessage {...messages.remoteReadingOwner} />}>
            {remoteReadingOwner}
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage {...messages.remoteReadingSerialPlaceholder} />}>
            {remoteReadingSerial}
          </Descriptions.Item>
        </>
      )}
      <Descriptions.Item label={<FormattedMessage {...messages.manufactured} />}>
        {manufactured?.year()}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.calibrated} />}>{calibrated?.year()}</Descriptions.Item>
    </Descriptions>
  );
};
